import {axios} from "@/api/config";
// 查询安全风险信息管理列表
export function listRiskDist(params) {
  return axios.get(`/riskDist/list`, params, true);
}

// 查询安全风险信息管理详细
export function getRiskDist(riskDistId) {
  return axios.get(`/riskDist/${riskDistId}`, riskDistId, true)
}

// 新增安全风险信息管理
export function addRiskDist(params) {
  return axios.post('/riskDist/addRiskDist', params, false);
}

// 修改安全风险信息管理
export function updateRiskDist(params) {
  return axios.post('/riskDist/editRiskDist', params, false);
}


// 删除安全风险信息管理
export function delRiskDist(riskDistId) {
  return axios.delete(`/riskDist/${riskDistId}`, true)
}

